import { z } from "zod";

export const BuyVigilsSchema = z.object({
  count: z.coerce.number().min(1, "Veuillez choisir au moins un compte"),
});

export const defaultBuyVigilsValues = {
  count: 1,
};

export type BuyVigilsForm = z.infer<typeof BuyVigilsSchema>;
